import { useSyncExternalStore } from "react";

let revokedAtPath: string | null = null;
const listeners = new Set<() => void>();

const notify = () => {
    listeners.forEach(listener => listener());
};

export const setDatabaseAccessRevoked = () => {
    revokedAtPath = window.location.pathname;
    notify();
};

export const resetDatabaseAccessRevoked = () => {
    revokedAtPath = null;
    notify();
};

export const useDatabaseAccessRevoked = (): boolean => {
    return useSyncExternalStore(
        callback => {
            listeners.add(callback);
            return () => {
                listeners.delete(callback);
            };
        },
        () =>
            revokedAtPath !== null &&
            revokedAtPath === window.location.pathname,
    );
};
